import React from "react";
import "./Styling.css";
import DateRangePicker from "./DateRangePicker";

const DashboardHeader = ({ startDate, endDate, onDateChange }) => {
  const today = new Date().toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="dashboard-header">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <div>
          <h1 className="db-title">Analytics Dashboard</h1>
          <p className="db-subtitle">
            Daily overview of your product enrichment metrics and user statistics
          </p>
        </div>
        <div>
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onDateChange}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
